export default {
    cancelButton: {
        name: 'Cancel',
        modalText: 'Confirm the cancellation of the order and specify the reason',
        buttonCancel: 'Go back to the order',
        buttonSend: 'Confirm',
        message: 'Failed to perform action',
        emptyReasonText: 'This order will be canceled without giving a reason. Are you sure?',
        noReasonsError: 'Failed to load order cancellation reasons',
    },

    editAfter: {
        name: 'Edit Order',
        message: 'Failed to change order status № {orderId}, contact CRM support',
    },

    refundButton: {
        modalText: 'Do you really want to initiate a refund?',
        buttonCancel: 'Back to order',
        buttonSend: 'Confirm',
        message: 'Failed to perform action',
    },

    issueOrder: {
        title: 'Check the code and issue the order',
        name: 'Issue an order',
        modalTitle: 'Checking the order issue code',
        modalText: 'Issue code:',
        buttonCheck: 'Check',
        buttonCancel: 'Cancel',
        messageCheckAttempts: 'The issue code was entered incorrectly 5 times. A request to the TP has been created, wait for a response',
        messageCode: 'You need to enter the issue code',
        messageError: 'Could not verify the issue code',
        placeholder: 'Enter the code from the sms',
        communication: 'Enter the four-digit code from the SMS that the buyer should tell you',
        appMobileTitle: 'APP printing',
        appMobileBody: 'It is necessary to print the APP and give the document to the client. To print the APP, go to the stationary PC.',
        appMobileOk: 'Good',
    },

    logButton: 'Order log',

    returnFrom: 'Return from delivery',

    sendCode: {
        name: 'Resend',
        text: 'Get a new code',
        messageConfirmation: 'Could not get the initial information',
        messageInfo: 'Failed to send the code',
    },

    issue: {
        title: 'Issuing an order without confirmation',
        name: 'Issue an order',
        message: 'Do you confirm that the order has been paid and issued to the customer?',
    },

    timeIncreased: {
        title: 'Send a notification about the extension of the order assembly period',
        name: 'The assembly period has been extended',
        message: 'Are you sure you want to send a notification to the customer about the extension of the order assembly period?',
    },

    issueToCourier: {
        buttonTitle: 'Issue to courier',
        modalTitle: 'Attention!',
        modalText: 'Do you confirm the transfer of the order to the courier?',
        modalOk: 'Confirmed',
        modalCancel: 'Cancel',
    },

    submit: {
        apply: 'Apply',
        reset: 'Reset',
    },

    reloadLabel: {
        okTitle: 'Yes',
        message: 'Do you really want to re-request a label?',
        labelRequest: 'Label Request',
        success: 'Label formed!',
        error: 'Failed to generate a label!',
        reRequest: 'Re-request label',
        close: 'Close',
    },
};